import { PolicyDocumentType } from '@acorn-portal/shared/src/services/api';

import { CoverLevel, Product, TelematicDeviceProvider } from '@acorn-portal/shared/src/services/interface/Shared';

export const ISO_UTC_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DISPLAY_DATE = 'dd/MM/yyyy';
export const DISPLAY_DATE_TIME = 'dd/MM/yyyy HH:mm';
export const DISPLAY_DATE_TIME_SECONDS = 'dd/MM/yyyy HH:mm:ss';
export const DISPLAY_DATE_TIME_AT = "dd/MM/yyyy 'at' HH:mm";
export const DISPLAY_API_DATE_FORMAT = 'yyyy-MM-dd';
export const MIN_AGE = 15;
export const MAX_VEHICLE_VALUE = 1000000;
export const DISPLAY_DATE_TIME_FULL_MONTH = 'dd MMMM yyyy, HH:mm ';

export const COMMON_LAW_PARTNER_VALUES = ['C', 'B', 'P'];

export const ACORN_CONTACT_NUMBER = '01704 339327';

export const FLAG_EXCESS_IPID_BOOKLET =
	'https://www.flaginsurance.co.uk/docs/Excess-Reimbursement/Haven-Insurance-Policy-Booklet-Excess-Reimbursement.pdf';

export const FLAG_EXCESS_IPID =
	'https://www.flaginsurance.co.uk/docs/Excess-Reimbursement/IPID-Excess-reimbursement.pdf';

export const FLAG_POLICY_BOOKLET =
	'https://haven.gi/docs/Taxi-Insurance/Taxi/Haven-Insurance-Policy-Booklet-Taxi-Plus.pdf';

export const FLAG_NCB_STATEMENT =
	'https://haven.gi/docs/No-Claims/No-Claims-Discount-No-Claims-Discount-Protection.pdf';

export const FLAG_IPID = 'https://haven.gi/docs/Taxi-Insurance/Taxi/IPID-Taxi-Plus.pdf';

export const FLAG_PRIVACY_POLICY = 'https://www.flaginsurance.co.uk/docs/Privacy-Notice.pdf';

export const FLAG_TERMS_OF_BUSINESS = 'https://www.flaginsurance.co.uk/docs/Terms-of-Business.pdf';

export const FLAG_KEYCARE_BOOKLET = 'https://haven.gi/docs/Add-Ons/Keycare/Flag-Keycare-Policy-Booklet.pdf';

export const FLAG_KEYCARE_IPID = 'https://haven.gi/docs/Add-Ons/Keycare/IPID-Flag-Keycare.pdf';

export const FLAG_TAXI_HIRE_BOOKLET =
	'https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/Haven-Insurance-Policy-Booklet-Taxi-Hire-Cover.pdf';

export const FLAG_TAXI_HIRE_IPID = 'https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/IPID-Taxi-Hire-Cover.pdf';

export const FLAG_BREAKDOWN_COVER_BOOKLET =
	'https://haven.gi/docs/Add-Ons/Breakdown/Haven-Insurance-Policy-Booklet-Breakdown-UK-European-Area.pdf';

export const FLAG_BREAKDOWN_COVER_IPID = 'https://haven.gi/docs/Add-Ons/Breakdown/IPID-Breakdown-cover.pdf';

export const ACORN_BREAKDOWN_COVER_BOOKLET =
	'https://haven.gi/docs/Add-Ons/Breakdown/Haven-Insurance-Policy-Booklet-Breakdown-UK-European-Area.pdf';

export const CARROT_BREAKDOWN_COVER_BOOKLET =
	'https://www.carrotinsurance.com/docs/Haven-Insurance-Policy-Booklet-Breakdown-UK-European-Area.pdf';

export const STREETCOVER_BREAKDOWN_COVER_BOOKLET =
	'https://haven.gi/docs/Add-Ons/Breakdown/Haven-Insurance-Policy-Booklet-Breakdown-UK-European-Area.pdf';

export const ACORN_BREAKDOWN_COVER_IPID = 'https://haven.gi/docs/Add-Ons/Breakdown/IPID-Breakdown-cover.pdf';

export const CARROT_BREAKDOWN_COVER_IPID = 'https://www.carrotinsurance.com/docs/IPID-Breakdown-cover.pdf';

export const STREETCOVER_BREAKDOWN_COVER_IPID = 'https://haven.gi/docs/Add-Ons/Breakdown/IPID-Breakdown-cover.pdf';

export const PRIVATE_CAR_POLICY_BOOKLET =
	'https://haven.gi/docs/Private-Car/Policy-Booklets/Haven-Insurance-Policy-Booklet-Private-Car-Plus.pdf';

export const MOTORCADE_POLICY_BOOKLET =
	'https://haven.gi/docs/Private-Car/Policy-Booklets/Haven-Insurance-Policy-Booklet-Private-Car-Plus.pdf';

export const MOTORCADE_IPID = 'https://haven.gi/docs/Private-Car/IPIDs/IPID-Private-Car-Plus.pdf';

export const MOTORCADE_TERMS_OF_BUSINESS = 'https://www.motorcade.co.uk/toba/';

export const CV_POLICY_BOOKLET =
	'https://haven.gi/docs/Commercial-Vehicle/Policy-Booklets/Haven-Insurance-Policy-Booklet-Commercial-Vehicle-Plus.pdf';

export const SHORT_TERM_PRIVATE_CAR_POLICY_BOOKLET =
	'https://www.acorninsure.co.uk/docs/PolicyBooklets/PrivateCarShortTerm/Haven-Policy-Booklet-Private-Car-Short-Term.pdf';

export const TAXI_ANNUAL_POLICY_BOOKLET =
	'https://haven.gi/docs/Taxi-Insurance/Taxi/Haven-Insurance-Policy-Booklet-Taxi-Plus.pdf';

export const TAXI_SHORT_TERM_POLICY_BOOKLET =
	'https://www.acorninsure.co.uk/docs/PolicyBooklets/TaxiShortTerm/Haven-Policy-Booklet-Taxi-Short-Term.pdf';

export const ACORN_PC_IPID = 'https://haven.gi/docs/Private-Car/IPIDs/IPID-Private-Car-Plus.pdf';

export const ACORN_CV_IPID = 'https://haven.gi/docs/Commercial-Vehicle/IPIDs/IPID-Commercial-Vehicle-Plus.pdf';

export const ACORN_PROTECT_POLICY_BOOKLET =
	'https://www.acorninsure.co.uk/docs/PolicyBooklets/Telematics/Haven-Policy-Booklet-Private-Car-Telematics.pdf';

export const ACORN_PROTECT_IPID =
	'https://www.acorninsure.co.uk/docs/IPIDs/PrivateCarIPIDs/IPID-Private-Car-Telematics-Plus.pdf';

export const ACORN_SHORT_TERM_IPID =
	'https://www.acorninsure.co.uk/docs/IPIDs/PrivateCarIPIDs/IPID-Private-Car-Short-term-All-cover-levels.pdf';

export const ACORN_SHORT_TERM_TAXI_IPID =
	'https://www.acorninsure.co.uk/docs/IPIDs/TaxiIPIDs/IPID-Taxi-Short-term-All-cover-levels.pdf';

export const ACORN_SUBSCRIPTION_IPID = 'https://haven.gi/docs/Private-Car/IPIDs/IPID-Subscription-Motor-Insurance.pdf';

export const ACORN_SUBSCRIPTION_POLICY_BOOKLET =
	'https://haven.gi/docs/Private-Car/Policy-Booklets/Haven-Insurance-Policy-Booklet-Subscription-Motor-Insurance.pdf';

export const ACORN_TAXI_ANNUAL_IPID = 'https://haven.gi/docs/Taxi-Insurance/Taxi/IPID-Taxi-Plus.pdf';

export const ACORN_XS_REIMBURSEMENT_IPID =
	'https://www.acorninsure.co.uk/docs/HavenDocuments/ExcessReimbursement/IPID-Excess-reimbursement.pdf';

export const MOTORCADE_XS_REIMBURSEMENT_IPID = 'www.motorcade.co.uk/docs/IPID-Excess-reimbursement.pdf';

export const ACORN_XS_REIMBURSEMENT_BOOKLET =
	'https://www.acorninsure.co.uk/docs/HavenDocuments/ExcessReimbursement/Haven-Insurance-Policy-Booklet-Excess-Reimbursement.pdf';

export const MOTORCADE_XS_REIMBURSEMENT_BOOKLET =
	'https://www.motorcade.co.uk/docs/Haven-Insurance-Policy-Booklet-Breakdown-UK-European-Area.pdf ';

export const ACORN_CONTACT_URL = 'https://www.acorninsure.co.uk/contact-us/';

export const MC_CONTACT_URL = 'https://www.motorcade.co.uk/contact-us/';

export const CARROT_CONTACT_URL = 'https://www.carrotinsurance.com/contact-us/';

export const FLAG_CONTACT_URL = 'https://www.flaginsurance.co.uk/get-in-touch/';

export const CARROT_NCB_STATEMENT = 'https://www.carrotinsurance.com/docs/cma-ncb-statement.pdf';

export const CARROT_IPID = 'https://www.carrotinsurance.com/docs/IPID-Telematics-Plus.pdf';

export const ACORN_NCB_STATEMENT =
	'https://haven.gi/docs/No-Claims/No-Claims-Discount-No-Claims-Discount-Protection.pdf';

export const MOTORCADE_NCB_STATEMENT =
	'https://haven.gi/docs/No-Claims/No-Claims-Discount-No-Claims-Discount-Protection.pdf';

export const ACORN_PRIVACY_POLICY = 'https://www.acorninsure.co.uk/docs/Privacy-Policy.pdf';

export const CARROT_PRIVACY_POLICY = 'https://www.carrotinsurance.com/privacy-policy-notice';

export const ACORN_TERMS_OF_BUSINESS = 'https://www.acorninsure.co.uk/docs/Terms-Of-Business.pdf';

export const CARROT_TERMS_OF_BUSINESS = 'https://www.carrotinsurance.com/docs/Terms-of-Business.pdf';

export const CARROT_POLICY_BOOKLET =
	'https://www.carrotinsurance.com/docs/Haven-Insurance-Policy-Booklet-Private-Car-Telematics-Plus.pdf';

export const CARROT_XS_REIMBURSEMENT_BOOKLET =
	'https://www.carrotinsurance.com/docs/Haven-Policy-Booklet-Private-Car-Excess-Reimbursement.pdf';

export const CARROT_XS_REIMBURSEMENT_IPID =
	'https://www.carrotinsurance.com/docs/IPIDPrivateCar-ExcessReimbursement.pdf';

export const MYPOLICY_NCB_STATEMENT = 'https://www.acorninsure.co.uk/docs/mypolicy/cma-ncb-statement.pdf';

export const MYPOLICY_IPID = 'https://www.acorninsure.co.uk/docs/mypolicy/IPID-Mileage-Telematicsv1.0.pdf';

export const MYPOLICY_TERMS_OF_BUSINESS =
	'https://www.mypolicy.co.uk/docs/policy-documents/haven/terms-of-business.pdf';

export const MYPOLICY_POLICY_BOOKLET =
	'https://www.acorninsure.co.uk/docs/mypolicy/Haven-Insurance-Policy-Booklet-Private-Car-Mileage-Telematicsv1.0.pdf';

export const MYPOLICY_XS_REIMBURSEMENT_BOOKLET =
	'https://www.acorninsure.co.uk/docs/mypolicy/Haven-Policy-Booklet-Private-Car-Excess-Reimbursement.pdf';

export const MYPOLICY_XS_REIMBURSEMENT_IPID =
	'https://www.acorninsure.co.uk/docs/mypolicy/IPIDPrivateCar-ExcessReimbursement-Comp.pdf';

export const MYPOLICY_CONTACT_URL = 'https://www.mypolicy.co.uk/get-in-touch/';

export const STREET_COVER_CONTACT_URL = 'https://www.streetcover.co.uk/contact-us/';

export const MYPOLICY_BREAKDOWN_COVER_IPID =
	'https://www.acorninsure.co.uk/docs/mypolicy/IPID-Private-car-breakdown-National-cover.pdf';

export const MYPOLICY_BREAKDOWN_COVER_BOOKLET =
	'https://www.acorninsure.co.uk/docs/mypolicy/IPID-Private-car-breakdown-National-cover.pdf';

export const MYPOLICY_PRIVACY_POLICY = 'https://www.acorninsure.co.uk/docs/mypolicy/080602-Retail-privacy-notice.pdf';

export const STREET_COVER_IPID = 'https://haven.gi/docs/Add-Ons/Breakdown/IPID-Breakdown-cover.pdf';
export const STREET_COVER_ANNUAL_POLICY_BOOKLET =
	'https://haven.gi/docs/Private-Car/Policy-Booklets/Haven-Insurance-Policy-Booklet-Private-Car-Plus.pdf';
export const STREET_COVER_TERMS_OF_BUSINESS = 'https://www.streetcover.co.uk/toba';
export const STREET_COVER_PRIVACY_POLICY = 'https://www.streetcover.co.uk/privacy-policy';
export const STREET_COVER_NCB_STATEMENT =
	'https://haven.gi/docs/No-Claims/No-Claims-Discount-No-Claims-Discount-Protection.pdf';
export const STREET_COVER_ANNUAL_IPID = 'https://haven.gi/docs/Private-Car/IPIDs/IPID-Private-Car-Plus.pdf';

export const STREET_COVER_30_DAY_POLICY_BOOKLET =
	'https://haven.gi/docs/Private-Car/Policy-Booklets/Haven-Insurance-Policy-Booklet-Street-Cover-30-day.pdf';

export const STREET_COVER_30_DAY_IPID =
	'https://haven.gi/docs/Private-Car/IPIDs/IPID-Private-Car-30-Day-Motor-Insurance.pdf';

export const STREET_COVER_NCB_PROTECTION =
	'https://haven.gi/docs/No-Claims/No-Claims-Discount-No-Claims-Discount-Protection.pdf';

export const OPTIONAL_EXTRAS_MONTHLY_COST_DISCLAIMER =
	'Please note that due to how this is calculated, the monthly cost of optional extras is an estimation and might differ slightly. Please review your quote before proceeding.';

export const ACORN_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, Acorn Insurance & Financial Services Limited act as a credit broker, not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement';

export const MOTORCADE_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, Motorcade (a trading name of Acorn Insurance & Financial Services Limited) act as a credit broker, not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement.';

export const CARROT_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, Carrot Insurance Services acts as a credit broker, not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement.';

export const FLAG_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, Flag Insurance (Brokers) a trading name of Acorn Financial Services act as a credit broker and not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement.';

export const MYPOLICY_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, My Policy act as a credit broker, not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement.';

export const STREET_COVER_INSTALMENT_CONFIRMATION_WORDING =
	'Please note when arranging instalment facilities, Street Cover (a trading name of Acorn Insurance & Financial Services Limited) act as a credit broker, not a lender. We only offer instalment facilities from one lender, which is Granite Finance Ltd. They are a sister company of ours who specialise in insurance premium finance. You will be required to enter into a credit agreement with Granite Finance Ltd, however Acorn Insurance & Financial Services Limited is the name that will appear on your bank statement.';

const DEMANDS_NEEDS_COMP_CV =
	'This product meets the demands and needs of someone who requires cover for their vehicle against fire, theft and accidental damage, and third-party liability cover for injury or damage they may cause to others.';

const DEMANDS_NEEDS_COMP_TAXI =
	'This product meets the demands and needs of someone who requires cover for their vehicle against fire, theft and accidental damage, and third-party liability cover for injury or damage they may cause to others.';

const DEMANDS_NEEDS_TPO_TAXI =
	'This product meets the demands and needs of someone who requires cover on a Third Party Only basis which provides third-party liability cover for injury or damage claimed by third parties in accordance with policy terms and conditions.;';

const DEMANDS_NEEDS_TPFT_TAXI =
	'This product meets the demands and needs of someone who requires protection for their vehicle on a Third Party, Fire and Theft basis which provides cover for your vehicle against fire and theft, and includes third-party liability cover for injury or damage claimed by third parties in accordance with policy limits and terms & conditions.';

const DEMANDS_NEEDS_TPFT_CV =
	'This product meets the demands and needs of someone who requires protection for their van on a Third Party, Fire and Theft basis which provides cover for your van against fire and theft, and includes third-party liability cover for injury or damage claimed by third parties in accordance with policy limits and terms & conditions.';

const DEMANDS_NEEDS_COMP_PC =
	'This product meets the demands and needs of someone who requires cover for their vehicle against fire, theft and accidental damage, and third-party liability cover for injury or damage they may cause to others.';

const DEMANDS_NEEDS_TPFT_PC =
	'This product meets the demands and needs of someone who requires protection for their car on a Third Party, Fire and Theft basis which provides cover for your car against fire and theft, and includes third-party liability cover for injury or damage claimed by third parties in accordance with policy limits and terms & conditions.';

const IMS_TELEMATICS_INSTALLATION_GUIDE =
	'You will receive a text message shortly after processing your change of vehicle asking you to book an engineer appointment to fit your new device. The device must be fitted to your car within 10 days of making this change, although you will be able to drive the vehicle immediately.';

const THINGCO_TELEMATICS_INSTALLATION_GUIDE =
	'If you change your car, you must keep the telematics tracking device. If a replacement cradle is required, this will be posted to you via recorded delivery. The telematics tracking device must be reinstalled in your new car and activated within 48 hours of receipt of your replacement cradle, or within 48 hours from the date you changed your vehicle if a new cradle is not required.';

const TRAKM8_TELEMATICS_INSTALLATION_GUIDE =
	'If you change your car, you must keep the telematics tracking device and it must be reinstalled in your new car and activated within 24 hours from the date you changed your vehicle.';

const HDEN_SELF_FIT_TELEMATICS_INSTALLATION_GUIDE =
	'If you change your vehicle, you must keep hold of the telematics tracking device and reinstall the device in your new vehicle. The device must be activated within 48 hours from the date you have set to change your vehicle. If you no longer have your device and require a new one, please complete your change of vehicle request and then contact your device provider to request a new device by emailing Carrot@howdendrivingdata.com';

export const PENALTY_POINTS = [
	{ value: '0', label: '0' },
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' },
	{ value: '5', label: '5' },
	{ value: '6', label: '6' },
	{ value: '7', label: '7' },
	{ value: '8', label: '8' },
	{ value: '9', label: '9' },
	{ value: '10', label: '10' },
	{ value: '11', label: '11' },
	{ value: '12', label: '12' },
];

export const COMPULSORY_EXCESS_CODES = [
	'XS_VEHICLE_GROUP',
	'XS_VEHICLE_MILEAGE',
	'XS_VEHICLE_VALUE',
	'XS_DRIVER',
	'XS_POLICY',
];

export enum addonDocumentEnums {
	XS_REIMBURSEMENT = 'XS_REIMBURSEMENT',
	XS_REIMBURSEMENT_BOOKLET = 'XS_REIMBURSEMENT_BOOKLET',
	UK_BREAKDOWN_COVER = 'UK_BREAKDOWN_COVER',
	NATIONAL_BREAKDOWN_COVER = 'NATIONAL_BREAKDOWN_COVER',
	KEYCARE = 'KEYCARE',
	NCB_PROTECTION = 'NCB_PROTECTION',
}

export enum genericDocumentEnums {
	PRIVACY_POLICY = 'PRIVACY_POLICY',
	TERMS_OF_BUSINESS = 'TERMS_OF_BUSINESS',
}

export type documentTypes = PolicyDocumentType | addonDocumentEnums | genericDocumentEnums;

export const DEFAULT_CLAIMS_SITE = 'https://www.acorninsure.co.uk/make-a-claim/?acn_source=direct';
export const DEFAULT_CONTACT_NUMBER = '01704 339 000';
export const DEFAULT_CLAIMS_NUMBER = ' 01732 747 100';
export const DEFAULT_RENEWAL_NUMBER = '01704 339327';
export const DEFAULT_EXISTING_CLAIM_NUMBER = '0330 331 0714';
export const DEFAULT_WINDSCREEN_NUMBER = '0345 092 0703';
export const DEFAULT_BD_NUMBER = '0330 331 0194';
export const DEFAULT_KEYCARE_NUMBER = '0345 303 0550';
export const DEFAULT_CANCELLED_NUMBER = '01704 339 000';
export const DEFAULT_VERIFICATION_NUMBER = '01704 339 983';
export const DEFAULT_AUTO_RENEW_CONTACT_NUMBER = '01704 339 327';

export const CARROT_CONTACT_NUMBER = '0208 629 3308';
export const TAXI_CONTACT_NUMBER = '01704 339 922';
export const TAXI_AUTO_RENEW_CONTACT_NUMBER = '01704 339 922';
export const ACORN_CANCELLED_NUMBER = '01704 339 000';
export const ACORN_TELEMATICS_CONTACT_NUMBER = '01704 339 200';
export const CARROT_CANCELLED_NUMBER = '0208 629 3308';
export const FLAG_CONTACT_NUMBER = '01344 452233';
export const FLAG_CANCELLED_NUMBER = '01344 452233';
export const MOTORCADE_AUTO_RENEW_CONTACT_NUMBER = '01704 795 188';
export const FLAG_AUTO_RENEW_CONTACT_NUMBER = '01344 452233';
export const PROTECT_YD_AUTO_RENEW_CONTACT_NUMBER = '01704 339 200';
export const CARROT_AUTO_RENEW_CONTACT_NUMBER = '0208 629 3308';
export const MYPOLICY_AUTO_RENEW_CONTACT_NUMBER = '0330 100 2337';

export const MYPOLICY_CONTACT_NUMBER = '0330 100 2337';
export const MYPOLICY_CANCELLED_NUMBER = '0330 100 2337';

export const STREETCOVER_CONTACT_NUMBER = '01704 795 185';
export const STREETCOVER_CANCELLED_NUMBER = '01704 795 185';

export const MOTORCADE_CONTACT_NUMBER = '01704 795 188';

export const PHONE_NUMBERS = {
	DEFAULT_CONTACT_NUMBER,
	DEFAULT_CLAIMS_NUMBER,
	DEFAULT_RENEWAL_NUMBER,
	DEFAULT_CANCELLED_NUMBER,
	DEFAULT_EXISTING_CLAIM_NUMBER,
	DEFAULT_WINDSCREEN_NUMBER,
	DEFAULT_BD_NUMBER,
	DEFAULT_KEYCARE_NUMBER,
	CARROT_CONTACT_NUMBER,
	TAXI_CONTACT_NUMBER,
	ACORN_TELEMATICS_CONTACT_NUMBER,
	ACORN_CANCELLED_NUMBER,
	CARROT_CANCELLED_NUMBER,
	FLAG_CONTACT_NUMBER,
	FLAG_CANCELLED_NUMBER,
	MYPOLICY_CONTACT_NUMBER,
	MYPOLICY_CANCELLED_NUMBER,
	STREETCOVER_CONTACT_NUMBER,
	STREETCOVER_CANCELLED_NUMBER,
	MOTORCADE_AUTO_RENEW_CONTACT_NUMBER,
	MOTORCADE_CONTACT_NUMBER,
	FLAG_AUTO_RENEW_CONTACT_NUMBER,
	PROTECT_YD_AUTO_RENEW_CONTACT_NUMBER,
	CARROT_AUTO_RENEW_CONTACT_NUMBER,
	MYPOLICY_AUTO_RENEW_CONTACT_NUMBER,
	TAXI_AUTO_RENEW_CONTACT_NUMBER,
	DEFAULT_AUTO_RENEW_CONTACT_NUMBER,
} as const;

type ProductKeys = keyof typeof Product;
type WithDefaultKey<T extends string, U extends string = 'DEFAULT'> = T | U;

type ExtractUsage<T extends string> = T extends `${WithDefaultKey<ProductKeys>}_${infer U}_NUMBER` ? U : never;
export type PhoneUsage = ExtractUsage<keyof typeof PHONE_NUMBERS>;

export type PhoneNumber = (typeof PHONE_NUMBERS)[keyof typeof PHONE_NUMBERS];

export const getContactUsUrl = (company: string) => {
	switch (company) {
		case 'ACORN':
			return ACORN_CONTACT_URL;
		case 'MOTORCADE':
			return MC_CONTACT_URL;
		case 'CARROT':
			return CARROT_CONTACT_URL;
		case 'FLAG':
			return FLAG_CONTACT_URL;
		case 'MYPOLICY':
			return MYPOLICY_CONTACT_URL;
		case 'STREETCOVER':
			return STREET_COVER_CONTACT_URL;
		default:
			return ACORN_CONTACT_URL;
	}
};

export const getTelematicsDeviceGuide = (telematicsProvider: TelematicDeviceProvider) => {
	const getDeviceGuide: Record<TelematicDeviceProvider, string> = {
		IMS: IMS_TELEMATICS_INSTALLATION_GUIDE,
		ThingCo: THINGCO_TELEMATICS_INSTALLATION_GUIDE,
		Howden: HDEN_SELF_FIT_TELEMATICS_INSTALLATION_GUIDE,
		TrakM8: TRAKM8_TELEMATICS_INSTALLATION_GUIDE,
	};
	return getDeviceGuide[telematicsProvider];
};

export const getCoverLevelText = (coverLevel: CoverLevel): string => {
	const coverLevelText: Record<CoverLevel, string> = {
		[CoverLevel.COMP]: 'Comprehensive',
		[CoverLevel.TPFT]: 'Third Party Fire & Theft',
		[CoverLevel.TPO]: 'Third Party Only',
	};

	return coverLevelText[coverLevel] || '';
};

export const getDemandsAndNeedsWording = (coverLevel: CoverLevel, product: Product): string | undefined => {
	switch (coverLevel) {
		case CoverLevel.COMP:
			if (product === Product.COMMERCIAL_VEHICLE) {
				return DEMANDS_NEEDS_COMP_CV;
			} else if (product === Product.TAXI) {
				return DEMANDS_NEEDS_COMP_TAXI;
			} else {
				return DEMANDS_NEEDS_COMP_PC;
			}
		case CoverLevel.TPFT:
			if (product === Product.COMMERCIAL_VEHICLE) {
				return DEMANDS_NEEDS_TPFT_CV;
			} else if (product === Product.TAXI) {
				return DEMANDS_NEEDS_TPFT_TAXI;
			} else {
				return DEMANDS_NEEDS_TPFT_PC;
			}
		case CoverLevel.TPO:
			if (product === Product.TAXI) {
				return DEMANDS_NEEDS_TPO_TAXI;
			}
			break;
		default:
			break;
	}
};

// === Employment Status Constants ===
export const EMPLOYED_STATUS_CODES = ['D', 'E', 'S', 'T', 'C', 'V'];
export const FULL_TIME_OCCUPATION = ['U', 'R', 'N', 'I', 'H'];
export const STUDENT_STATUS_CODES = ['F'];

// === Driver License Constants ===
export const DLN_GENDER_CODES = ['002', '003', '004', '005'];

// === Vehicle Usage Constants ===
export const NON_BUSINESS_VEHICLE_CODES = ['01', '1', '4', '04', '17', '15'];
export const TAXI_USAGE_CODES = ['15', '17'];

// === Currency and Formatting Constants ===
export const GBP_CURRENCY_CONFIG = {
	style: 'currency' as const,
	currency: 'GBP',
	locale: 'en-GB',
};
